<div class="button-demo">
    <button class="cxone-btn btn-small btn-secondary" (click)="viewReason()" id="view-reason">{{viewButton}}</button>
</div>